













































import Vue, { PropType } from 'vue'
import Icon from '@/ui/icon/Icon.vue'
import { TreeData } from '@/features/api/types'

export default Vue.extend({
  name: 'SelectItemRecursive',
  components: {
    Icon,
  },
  props: {
    item: {
      type: Object as PropType<{ id: number; leaves: TreeData[]; name: string; title: string }>,
    },
    active: { type: Boolean as PropType<boolean> },
    withIcon: { type: Boolean as PropType<boolean> },
    depth: { type: Number as PropType<number> },
    selectedItemId: { type: Number as PropType<number> },
    selectedItemsIds: { type: Array as PropType<number[]> },
    handleClick: { type: Function },
    disabledElement: { type: Number },
  },
  computed: {
    indent() {
      return { paddingLeft: `${(this.depth + 1) * 20}px` }
    },
    showTick() {
      if (
        this.selectedItemsIds &&
        this.selectedItemsIds.find((el: any) => +el.name === this.item.id)
      )
        return true
      if (this.selectedItemId && this.selectedItemId === this.item.id) return true
      return false
    },
  },
})
